import { render, staticRenderFns } from "./DownloadPDF.vue?vue&type=template&id=166d7d76"
import script from "./DownloadPDF.vue?vue&type=script&lang=js"
export * from "./DownloadPDF.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports